import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository'
import {
  DashboardClassroomDiagnosticTrigger,
  DashboardClassroomDiagnosticTriggerInput
} from '@/core/domain/dashboard/DashboardClassroomDiagnosticTrigger'
import { QuizType } from '@/core/domain/resources/enums/QuizType'

/**
 * Use case pour publier un diagnostic pour une classe
 */
export class PublishClassroomDiagnosticUseCase {
  private dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    classroomId: number,
    diagnosticType: string,
    courseName: string = 'Andromède'
  ): Promise<DashboardClassroomDiagnosticTrigger[]> {
    // Déterminer le type de quiz basé sur le type de diagnostic
    const quizType =
      diagnosticType === 'T1'
        ? QuizType.Values.EXPLORATION_ANDROMEDE
        : QuizType.Values.EXPLORATION_ANDROMEDE

    // Créer l'input pour le trigger
    const triggerInput = DashboardClassroomDiagnosticTriggerInput.create({
      id: 0, // Will be set by the server
      schoolClassroomId: classroomId,
      learningCourseName: courseName,
      quizType: quizType,
      triggerTime: new Date().toISOString()
    })

    return await this.dashboardRepository.createDashboardClassroomDiagnosticTrigger(
      classroomId,
      triggerInput
    )
  }
}
